export default {
  DELAY_RESULT: 12,
  RELEASE_RESULT_TIME: 5,
  TOTAL_RELEASE_RESULT_TIME: 100,
  PUBLIC_URL: ['/', '/home', '/login'],
  WAITING__DEV_RESULT: 60,
  WAITING__PRO_RESULT: 300,
};
